import React from 'react';
import TranscriptUploadPage from './TranscriptUploadPage';

const TranscriptStepIntakePage = ({
  paginationMeta,
  nextOnClick,
  prevOnClick,
}) => (
  <TranscriptUploadPage
    paginationMeta={paginationMeta}
    nextOnClick={nextOnClick}
    prevOnClick={prevOnClick}
    categoryId="story"
    questionId="document"
    optionId="transcript"
    backgroundOverlay="/assets/profile/wholeMe/resume/resume-upload-overlay.svg"
  />
);

export default TranscriptStepIntakePage;
